<template>
  <div class="stage">
    <div class="stage__animation" ref="animationContainer"></div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/modules.scss';

  .stage {
    position: relative;
    width: 100%;
    height: 100%;
    top: -20px;
    // background-image: url($static-path + 'img/factory/bg_factory_main.png');
    // background-size: 100% auto;
    // background-repeat: no-repeat;
  }
</style>

<script>
  import Constant from '@/constant';
  import lottie from 'lottie-web';

  export default {
    name: 'Stage',
    props: ['passedTestState'],

    data () {
      return {
        staticPath: Constant.STATICPATH,
        animationFileIndex: 0,
        animationFilePath: '',
        timerId: 0
      }
    },

    mounted () {

      this.createAnim();
    },

    methods: {

      createAnim() {

        let animation_box = null;

        if (this.$refs && this.$refs.animationContainer) {
          animation_box = this.$refs.animationContainer;
        }

        if (! animation_box) {
          return;
        }

        if (this.anim && (typeof this.anim) == 'object' && Object.keys(this.anim).length > 0) {
          
          const anim_path = this.anim.path + this.anim.fileName + '.json';

          if (anim_path == this.animationFilePath) {
            return;
          }

          this.anim.destroy();
        }

        if (! this.animationFilePath ) {
          this.animationFilePath = this.staticPath + 'lottie/factory/clear_0-0/data.json';
        }

        this.anim = lottie.loadAnimation({
            container: animation_box,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            prerender: true,
            path: this.animationFilePath
          }
        );

        // ロードできなかった場合はデフォルトのアニメーション設定
        clearTimeout(this.timerId);

        this.timerId = setTimeout( () => {

          if (this.anim && ! this.anim.isLoaded) {

            this.anim.destroy();

            this.animationFilePath = this.staticPath + 'lottie/factory/clear_0-0/data.json';

            this.anim = lottie.loadAnimation({
                container: animation_box,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                prerender: true,
                path: this.animationFilePath
              }
            );
          }

          clearTimeout(this.timerId);

        }, 3000);
      }
    },

    watch: {

      // 合格テストリストの値を反映
      passedTestState(val) {

        const passed_items = this.$store.getters['PassedTest/items'];
        const passed_num = passed_items.length;

        let study_no = 0;
        let exam_no = 0;

        for (let i=0; i < passed_num; i++) {

          const item = passed_items[i];

          if (item.testType == 'study') {

            if (item.testId == 1) {
              if (study_no <= 1) {
                study_no = 1;
              }
            } else if (item.testId == 2) {
              study_no = 2;
            }

          } else if (item.testType == 'exam') {

            if (item.testId == 1) {
              if (exam_no <= 1) {
                exam_no = 1;
              }
            } else if (item.testId == 2) {
              exam_no = 2;
            }
          }
        }

        const dir_name = 'clear_' + study_no + '-' + exam_no;
        const file_path = this.staticPath + 'lottie/factory/' + dir_name + '/data.json';

        // 値に変化がある場合アニメーション作り直し
        if (this.animationFilePath !== file_path) { 
          this.animationFilePath = file_path;
          this.createAnim();
        }
      }
    },

    beforeDestroy () {
      clearTimeout(this.timerId);
      this.anim.destroy();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Factory/Stage.vue